import { REGIONS } from './locations.js';

// 地域 → 国 → 都市 の段階選択ピッカー。container に描画し、都市が選ばれたら
// onChoose({ lat, lng, name, elevation, lookAt }) を呼ぶ。
export function createLocationPicker({ container, onChoose, leadEl }) {
  let stage = 'region'; // 'region' | 'country' | 'city'
  let region = null;
  let country = null;

  const LEAD = {
    region: '地域を選択してください / Select a region',
    country: '国を選択してください / Select a country',
    city: '出発する都市を選択してください / Select a departure city',
  };

  function makeBtn(icon, title, desc, onClick) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'mode-btn';
    const i = document.createElement('span');
    i.className = 'mode-icon';
    i.textContent = icon;
    const t = document.createElement('span');
    t.className = 'mode-title';
    t.textContent = title;
    const d = document.createElement('span');
    d.className = 'mode-desc';
    d.textContent = desc;
    b.append(i, t, d);
    b.addEventListener('click', onClick);
    return b;
  }

  function render() {
    container.innerHTML = '';
    if (leadEl) leadEl.textContent = LEAD[stage];

    // 戻る + パンくず
    if (stage !== 'region') {
      const bar = document.createElement('div');
      bar.className = 'picker-bar';
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'picker-back';
      back.textContent = '← 戻る / Back';
      back.addEventListener('click', () => {
        if (stage === 'city') { stage = 'country'; country = null; }
        else if (stage === 'country') { stage = 'region'; region = null; }
        render();
      });
      const crumb = document.createElement('span');
      crumb.className = 'picker-crumb';
      crumb.textContent = [region, country]
        .filter(Boolean)
        .map((x) => `${x.name} ${x.nameEn}`)
        .join(' › ');
      bar.append(back, crumb);
      container.appendChild(bar);
    }

    const grid = document.createElement('div');
    grid.className = 'mode-buttons';

    if (stage === 'region') {
      for (const r of REGIONS) {
        grid.appendChild(
          makeBtn(r.emoji, r.name, r.nameEn, () => {
            region = r; stage = 'country'; render();
          })
        );
      }
    } else if (stage === 'country') {
      for (const c of region.countries) {
        grid.appendChild(
          makeBtn(c.emoji, c.name, c.nameEn, () => {
            country = c; stage = 'city'; render();
          })
        );
      }
    } else {
      for (const city of country.cities) {
        grid.appendChild(
          makeBtn(country.emoji, city.name, city.nameEn ?? '', () => onChoose(city))
        );
      }
    }

    container.appendChild(grid);
  }

  render();

  return {
    reset() {
      stage = 'region';
      region = null;
      country = null;
      render();
    },
  };
}
